import { render, staticRenderFns } from "./RegimenReportCard.vue?vue&type=template&id=bf401024"
import script from "./RegimenReportCard.vue?vue&type=script&lang=js"
export * from "./RegimenReportCard.vue?vue&type=script&lang=js"
import style0 from "./RegimenReportCard.vue?vue&type=style&index=0&id=bf401024&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports